export default __webpack_public_path__ + "static/media/icons8-car-service.edeb965e.svg";